module.exports = __webpack_public_path__ + "img/DTI-03.bfb97231.png";